import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IRefreshTokenRequest, IRefreshTokenResponse } from '../models/refresh-token.model';
import { fromRefreshTokenActions } from '../actions';

export const refreshTokenFeatureKey = 'refreshToken';

export interface RefreshTokenState {
  loadRefreshTokenRequest: IRefreshTokenRequest;
  loadRefreshTokenResponse: IRefreshTokenResponse;
  loadRefreshTokenFailure: IGenericError<ErrorResponse>;
}

export const initialState: RefreshTokenState = {
  loadRefreshTokenFailure: undefined,
  loadRefreshTokenRequest: undefined,
  loadRefreshTokenResponse: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromRefreshTokenActions.loadRefreshTokenRequest, (state, action) => ({
    ...state,
    loadRefreshTokenRequest: action.request
  })),

  on(fromRefreshTokenActions.loadRefreshTokenSuccess, (state, action) => ({
    ...state,
    loadRefreshTokenResponse: action.response
  })),

  on(fromRefreshTokenActions.loadRefreshTokenFailure, (state, action) => ({
    ...state,
    loadRefreshTokenFailure: action.error
  })),

  on(fromRefreshTokenActions.clearRefreshToken, (state, action) => ({
    ...state,
    loadRefreshTokenResponse: undefined
  }))
);

export const refreshTokenResponse = (state: RefreshTokenState) => state.loadRefreshTokenResponse;
